<template>
    <div>
        <ClienteHeader></ClienteHeader>
        <router-view class="container">
        </router-view>
    </div>
</template>

<script>
import ClienteHeader from "./Cabecalho";
    export default {
    components: { ClienteHeader },

    data() {
        return {
            validationToken: true
        }
    },

    methods: {

    convertToken(token) {
          var base64Url = token.split('.')[1];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));
          return JSON.parse(jsonPayload);
      }
    },
  created() {
    this.validateToken()
  },  
}


</script>

<style lang="scss" scoped>

</style>